import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3736884e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "collection",
  style: { 'margin-top': '5px' }
}
const _hoisted_2 = { class: "start-info" }
const _hoisted_3 = { class: "collection-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "share" }, "分享", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_share = _resolveComponent("share")!
  const _component_templete = _resolveComponent("templete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isStore == 0)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addStart && _ctx.addStart(...args))),
            class: "icon iconfont icon-shoucang2 collection-icon-no"
          }))
        : _createCommentVNode("", true),
      (_ctx.isStore == 1)
        ? (_openBlock(), _createElementBlock("i", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addStart && _ctx.addStart(...args))),
            class: "icon iconfont icon-shoucang1 collection-icon-yes"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: _normalizeClass(["title collection-icon", {
          'collection-icon-yes': _ctx.isStore == 1,
          'collection-icon-no': _ctx.isStore == 0,
        }]),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addStart && _ctx.addStart(...args)))
      }, "收藏方案", 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_templete, null, {
        default: _withCtx(() => [
          _createVNode(_component_share, {
            douban: true,
            QZone: false,
            url: _ctx.routerPath,
            title: _ctx.goods.names ? _ctx.goods.names : _ctx.goods.name,
            description: _ctx.goods.content ? _ctx.goods.content : _ctx.goods.desc,
            image: _ctx.getLocalImgurl(_ctx.goods)
          }, null, 8, ["url", "title", "description", "image"])
        ]),
        _: 1
      })
    ])
  ]))
}